/**
 * API error taxonomy.
 *
 * - `ApiError`: any non-2xx response, or schema validation failure.
 * - `AuthError`: 401 after a refresh attempt failed; `tokenStore` cleared.
 */

export class ApiError extends Error {
  readonly status: number
  readonly body: unknown

  constructor(status: number, message: string, body?: unknown) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.body = body
  }
}

export class AuthError extends ApiError {
  constructor(message = 'Authentication required', body?: unknown) {
    super(401, message, body)
    this.name = 'AuthError'
  }
}
